// src/services/pricingService.js
// Service for pricing calculations and date-based price mapping

export function calculateDailyPrices(seasonalRates, seasonalDates) {
  const dailyPrices = {};

  if (!seasonalRates || !seasonalDates) {
    return dailyPrices;
  }

  // Create a map of season_id to rate - handle API response structure
  const rateMap = seasonalRates.reduce((acc, rate) => {
    // Handle Go sql.Null* types structure and direct values
    const seasonId = rate.SeasonID?.Valid ? rate.SeasonID.Int32 : rate.SeasonID || rate.season_id;
    const dailyRateStr = rate.DailyRate?.Valid ? rate.DailyRate.String : rate.DailyRate || rate.daily_rate;
    const dailyRate = parseFloat(dailyRateStr);

    // Use the last occurrence to get the most recent/correct rate
    if (seasonId && dailyRate) {
      acc[seasonId] = dailyRate;
    }
    return acc;
  }, {});

  // Generate daily prices for each date range
  seasonalDates.forEach(dateRange => {
    // Handle different response formats (Go time.Time vs direct strings)
    const startDateStr = dateRange.StartDate?.Valid ? dateRange.StartDate.Time : dateRange.StartDate || dateRange.start_date;
    const endDateStr = dateRange.EndDate?.Valid ? dateRange.EndDate.Time : dateRange.EndDate || dateRange.end_date;
    const seasonId = dateRange.SeasonID?.Valid ? dateRange.SeasonID.Int32 : dateRange.SeasonID || dateRange.season_id;

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const dailyRate = rateMap[seasonId];

    if (dailyRate && !isNaN(startDate) && !isNaN(endDate)) {
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
        dailyPrices[dateStr] = dailyRate;
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
  });
  return dailyPrices;
}

export function getPriceForDate(date, dailyPrices) {
  if (!date || !dailyPrices) return 0;
  
  const dateStr = typeof date === 'string' ? date : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return dailyPrices[dateStr] || 0;
}

export function getReservedDates() {
  // TODO: Fetch from bookings API when available
  return [
    "2025-01-15",
    "2025-01-16", 
    "2025-01-17",
    "2025-01-25",
    "2025-01-26",
    "2025-01-27",
    "2025-01-28",
    "2025-02-10",
    "2025-02-11",
    "2025-02-12",
    "2025-08-15",
    "2025-08-16",
    "2025-08-17",
  ];
}


// DEPRECATED: Use fetchSeasonalDates from vehicleService instead
// This function is kept for backward compatibility but should not be used
export function getSeasonalDates() {
  // Deprecated: This returns empty array. Use fetchSeasonalDates from vehicleService.js
  console.warn('getSeasonalDates() is deprecated. Use fetchSeasonalDates() from vehicleService instead.');
  return [];
}